module.exports = __webpack_public_path__ + "img/AI_TRANSLATE.3226862c.svg";